import FilterChipStrip from "./FilterChipStrip";

/**
 * The persistent strip in the app shell.
 *
 * It replaces the old always-expanded Collapse: the full dashboard is a focused
 * task and lives in a drawer (§26), while what stays on the page is the part
 * the user needs at a glance — which filters are on, and the way back in.
 *
 * The strip + drawer themselves live in `FilterChipStrip`, shared with /home's
 * own page-header strip (`home-page-header-filter-chips`) — this component
 * only owns the shell-level margins.
 */
export default function FilterBar() {
  return <FilterChipStrip className="mx-3 mb-4 sm:mx-6" />;
}
